import { ArrowForwardIos } from "@mui/icons-material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import EditIcon from "@mui/icons-material/Edit";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";
import {
  Box,
  Card,
  CardContent,
  Grid,
  ImageList,
  ImageListItem,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { Typography } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { default as api, default as Api } from "../API/api";
import { loginState, WHState } from "../Atom/AtomState";
import AlertComponent from "../CommonComponent/Alert/AlertComponent";
import ButtonComponent from "../CommonComponent/Inputs/ButtonComponent";
import MultiSelectComponent from "../CommonComponent/Inputs/MultiSelectComponent";
import SelectComponent from "../CommonComponent/Inputs/SelectComponent";
import TextComponent from "../CommonComponent/Inputs/TextComponent";
import Loading from "../CommonComponent/LoadingBar/Loading";
import "../CSS/PageCSS/ConsultDetailPage.css";
import BodySizeModal from "../CommonComponent/Modal/BodySizeModal";
import FaceSizeModal from "../CommonComponent/Modal/FaceSizeModal";
import { filesList } from "../CommonComponent/CommonFunction";

const { Title } = Typography;

export default function ConsultDetailPage() {
  const location = useLocation();
  const key = location.state;
  let navigate = useNavigate();
  const LoginState = useRecoilValue(loginState);
  const WH = useRecoilValue(WHState);
  const [alert, setAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [divboxHeight, setdivBoxHeight] = useState<number>(0);
  const [pictureHeight, setPictureHeight] = useState<number>(0);
  const [employeeData, setEmployeeData] = useState<any>();
  const [questionResultListData, setQuestionResultListData] = useState<any>();
  const [loading, setLoading] = useState(false);
  const [questionData, setQuestionData] = useState<any>();
  const [consultProgramData, setConsultProgramData] = useState<any>();
  const [colorTypeData, setColorTypeData] = useState<any>();
  const [pccConsultListData, setPccConsultListData] = useState<any>([]);
  const [usercolorPccsConsultData, setUserColorPccsConsultData] = useState<any>(
    []
  );
  const [numberQuestionListData, setNumberQuestionListData] = useState<any>();
  const [colorPccsData, setColorPccsData] = useState<any>();
  const [fitTypeData, setFitTypeData] = useState<any>();
  const [faceTypeData, setFaceTypeData] = useState<any>();
  const [consultData, setConsultData] = useState<any>({
    p_id: 0,
    customer_id: 0,
    employee_id: 0,
    consult_program_id: 0,
    consult_date: dayjs(new Date()),
    finyn: 0,
    color_type: 0,
    fit_type: 0,
    face_type: 0,
    characteristic1: "",
    characteristic2: "",
    characteristic3: "",
    significant: "",
    issue: "",
    brand_color: "",
    brand_fit: "",
    memo: "",
    insert_time: dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss"),
    files: [],
  });
  const [bodydisable, setBodyDisable] = useState(true);
  const [bodyModal, setBodyModal] = useState({
    value: false,
    state: "view",
  });
  const [faceModal, setFaceModal] = useState({
    value: false,
    state: "view",
  });
  const [BodyResult, setBodyResult] = useState({
    arm: "N",
    chest: 0,
    gender: "F",
    hip: 0,
    leg: "N",
    p_id: 0,
    shoulder: 0,
    type1: "",
    type2: "",
    waist: 0,
  });

  const [faceResult, setFaceResult] = useState({
    clown: 0,
    face: 0,
    forehead: 0,
    chin: 0,
    chin_col: 0,
    edge: 0,
  });

  const changeTextField = (value: any) => {
    if (value.name == "significant") {
      setConsultData((prev: any) => ({
        ...prev,
        significant: value.value,
      }));
    } else if (value.name == "issue") {
      setConsultData((prev: any) => ({
        ...prev,
        issue: value.value,
      }));
    } else if (value.name == "memo") {
      setConsultData((prev: any) => ({
        ...prev,
        memo: value.value,
      }));
    } else if (value.name == "characteristic1") {
      setConsultData((prev: any) => ({
        ...prev,
        characteristic1: value.value,
      }));
    } else if (value.name == "characteristic2") {
      setConsultData((prev: any) => ({
        ...prev,
        characteristic2: value.value,
      }));
    } else if (value.name == "characteristic3") {
      setConsultData((prev: any) => ({
        ...prev,
        characteristic3: value.value,
      }));
    } else if (value.name == "brand_color") {
      setConsultData((prev: any) => ({
        ...prev,
        brand_color: value.value,
      }));
    } else if (value.name == "brand_fit") {
      setConsultData((prev: any) => ({
        ...prev,
        brand_fit: value.value,
      }));
    }
  };

  const changeSelect = (value: any) => {
    if (value.name == "employee_id") {
      setConsultData((prev: any) => ({
        ...prev,
        employee_id: value.value,
      }));
    } else if (value.name == "consult_program_id") {
      setConsultData((prev: any) => ({
        ...prev,
        consult_program_id: value.value,
        color_type: 0,
        fit_type: 0,
        face_type: 0,
        characteristic1: "",
        characteristic2: "",
        characteristic3: "",
        brand_color: "",
        brand_fit: "",
      }));
      setUserColorPccsConsultData([]);
      setBodyModal({
        value: false,
        state: "view",
      });
      setBodyDisable(true);
    } else if (value.name == "color_type") {
      setConsultData((prev: any) => ({
        ...prev,
        color_type: value.value,
      }));
    } else if (value.name == "fit_type") {
      setConsultData((prev: any) => ({
        ...prev,
        fit_type: value.value,
      }));
    } else if (value.name == "face_type") {
      setConsultData((prev: any) => ({
        ...prev,
        face_type: value.value,
      }));
    }
  };

  const changeMultiSelect = (value: any) => {
    setUserColorPccsConsultData(
      typeof value.value === "string" ? value.value.split(",") : value.value
    );
  };

  const changeDateField = (value: any) => {
    if (value.name == "consult_date") {
      setConsultData((prev: any) => ({
        ...prev,
        consult_date: value,
      }));
    }
  };

  const handleSave = () => {
    const getUpdate = async () => {
      setLoading(true);
      const formData = new FormData();
      formData.append("p_id", consultData.p_id);
      formData.append("employee_id", consultData.employee_id);
      formData.append("consult_program_id", consultData.consult_program_id);
      formData.append(
        "consult_date",
        consultData.consult_date.format("YYYY-MM-DD HH:mm:ss")
      );
      formData.append("color_type", consultData.color_type);
      formData.append("fit_type", consultData.fit_type);
      formData.append("face_type", consultData.face_type);
      formData.append("characteristic1", consultData.characteristic1);
      formData.append("characteristic2", consultData.characteristic2);
      formData.append("characteristic3", consultData.characteristic3);
      formData.append("significant", consultData.significant);
      formData.append("issue", consultData.issue);
      formData.append("brand_color", consultData.brand_color);
      formData.append("brand_fit", consultData.brand_fit);
      formData.append("memo", consultData.memo);
      formData.append("pccs", usercolorPccsConsultData);
      formData.append("arm", BodyResult.arm);
      formData.append("chest", BodyResult.chest.toString());
      formData.append("gender", BodyResult.gender);
      formData.append("hip", BodyResult.hip.toString());
      formData.append("leg", BodyResult.leg);
      formData.append("shoulder", BodyResult.shoulder.toString());
      formData.append("waist", BodyResult.waist.toString());
      formData.append("type1", BodyResult.type1);
      formData.append("type2", BodyResult.type2);
      formData.append("clown", faceResult.clown.toString());
      formData.append("face", faceResult.face.toString());
      formData.append("forehead", faceResult.forehead.toString());
      formData.append("chin", faceResult.chin.toString());
      formData.append("chin_col", faceResult.chin_col.toString());
      formData.append("edge", faceResult.edge.toString());

      const updateData = await Api.put(`/Consult/updateConsult`, formData);
      setLoading(false);
      if (updateData != undefined) {
        navigate(0);
      } else {
        setAlert(true);
        setAlertMessage("컨설팅 정보 수정에 실패하였습니다.");
      }
    };

    var result = false;

    if (
      consultData.employee_id != 0 &&
      consultData.employee_id != "" &&
      consultData.consult_program_id != null &&
      consultData.consult_program_id != "" &&
      consultData.consult_date.isValid()
    ) {
      if (consultData.consult_program_id == 1 && consultData.color_type != 0) {
        result = true;
      } else if (
        consultData.consult_program_id == 2 &&
        consultData.fit_type != 0
      ) {
        result = true;
      } else if (
        consultData.consult_program_id == 3 &&
        consultData.color_type != 0 &&
        consultData.face_type != 0
      ) {
        result = true;
      } else if (
        consultData.consult_program_id == 4 &&
        consultData.color_type != 0 &&
        consultData.fit_type != 0
      ) {
        result = true;
      } else if (
        consultData.consult_program_id == 5 &&
        consultData.fit_type != 0 &&
        consultData.face_type != 0
      ) {
        result = true;
      } else if (
        consultData.consult_program_id == 6 &&
        consultData.color_type != 0 &&
        consultData.fit_type != 0 &&
        consultData.face_type != 0
      ) {
        result = true;
      }

      if (result == true) {
        getUpdate();
      } else {
        setAlert(true);
        setAlertMessage("컨설팅 일자, 담당자, 프로그램, 타입을 채워주세요");
      }
    } else {
      setAlert(true);
      setAlertMessage("컨설팅 일자, 담당자, 프로그램, 타입을 채워주세요");
    }
  };

  useEffect(() => {
    if (key == null) {
      navigate("/NotFoundPage");
    } else {
      const getData = async () => {
        setLoading(true);
        const consult = await api.get(
          `/Consult/getConsultInfo?p_id=${key.p_id}`
        );

        const question = await api.get(`/Question/getAllQuestionList`);

        const questionresult = await api.get(
          `/Question/getQuestionResult?p_id=${key.p_id}`
        );

        const numberquestion = await api.get(
          `/Question/getNumberQuestion?language=1`
        );

        const allpccs = await api.get(`/Consult/getPccsAllData`);

        const pccs = await api.get(`/Consult/getPccsData?p_id=${key.p_id}`);

        const employee = await api.get("/Employee/getEmployeeList");

        const consultprogram = await api.get("/Consult/getConsultProgramList");

        const colortype = await api.get(`/Consult/getColorType`);

        const fittype = await api.get(`/Consult/getFitType`);

        const facetype = await api.get(`/Consult/getFaceType`);
        setLoading(false);
        if (
          consult != undefined ||
          question != undefined ||
          questionresult != undefined ||
          numberquestion != undefined ||
          allpccs != undefined ||
          pccs != undefined ||
          employee != undefined ||
          consultprogram != undefined ||
          colortype != undefined ||
          fittype != undefined ||
          facetype != undefined
        ) {
          const newItem = {
            ...consult[0],
            consult_date:
              consult[0].consult_date == null
                ? dayjs(new Date())
                : dayjs(consult[0].consult_date),
          };
          setConsultData(newItem);
          setQuestionData(question);
          setQuestionResultListData(questionresult);
          setNumberQuestionListData(numberquestion);
          setColorPccsData(allpccs);
          setPccConsultListData(pccs);
          setUserColorPccsConsultData(pccs.map((item: any) => item.pccs_id));
          setEmployeeData(employee);
          setConsultProgramData(consultprogram);
          setColorTypeData(colortype);
          setFitTypeData(fittype);
          setFaceTypeData(facetype);
        } else {
          setAlert(true);
          setAlertMessage("데이터 조회에 실패하였습니다.");
        }
      };
      getData();
    }
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const div = document.getElementById("divbox") as HTMLElement;
      const ConsultDetailControlDiv = document.getElementById(
        "ConsultDetailControlDiv"
      ) as HTMLElement;
      const PersonInformation = document.getElementById(
        "PersonInformation"
      ) as HTMLElement;
      if (div && ConsultDetailControlDiv) {
        setdivBoxHeight(
          div.clientHeight - ConsultDetailControlDiv.clientHeight - 40
        );
      }
      if (PersonInformation) {
        setPictureHeight(PersonInformation.clientHeight - 90);
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  });

  return (
    <div style={{ height: WH.height - 160 }}>
      <Title level={2} className="ConsultDetailTitle">
        ConsultDetailPage
      </Title>
      <div id="divbox">
        <Card className="ConsultDetailCard">
          <CardContent
            className="ConsultDetailCardContent"
            sx={{
              height: divboxHeight,
            }}
          >
            <Grid container spacing={2}>
              <Grid size={{ xs: 12, md: 12, lg: 6, xl: 6 }}>
                <Box id="PersonInformation">
                  <Title level={3} className="ConsultDetailName">
                    <AccountCircleIcon
                      fontSize="small"
                      className="ConsultAnswerIcon"
                    />
                    고객정보
                  </Title>
                  <Box className="ConsultDetailForm">
                    <Title level={4} className="ConsultDetailName">
                      성함
                    </Title>
                    <Title level={5} className="ConsultDetailName">
                      <ArrowForwardIos
                        fontSize="small"
                        className="ConsultAnswerIcon"
                      />
                      {consultData.name}
                    </Title>
                  </Box>
                  <Box className="ConsultDetailForm">
                    <Title level={4} className="ConsultDetailName">
                      연령
                    </Title>
                    <Title level={5} className="ConsultDetailName">
                      <ArrowForwardIos
                        fontSize="small"
                        className="ConsultAnswerIcon"
                      />
                      {consultData.age}
                    </Title>
                  </Box>{" "}
                  <Box className="ConsultDetailForm">
                    <Title level={4} className="ConsultDetailName">
                      국가
                    </Title>
                    <Title level={5} className="ConsultDetailName">
                      <ArrowForwardIos
                        fontSize="small"
                        className="ConsultAnswerIcon"
                      />
                      {consultData.country_name}
                    </Title>
                  </Box>
                  <Box className="ConsultDetailForm">
                    <Title level={4} className="ConsultDetailName">
                      성별
                    </Title>
                    <Title level={5} className="ConsultDetailName">
                      <ArrowForwardIos
                        fontSize="small"
                        className="ConsultAnswerIcon"
                      />
                      {consultData.sex}
                    </Title>
                  </Box>
                  <Box className="ConsultDetailForm">
                    <Title level={4} className="ConsultDetailName">
                      이메일
                    </Title>
                    <Title level={5} className="ConsultDetailName">
                      <ArrowForwardIos
                        fontSize="small"
                        className="ConsultAnswerIcon"
                      />
                      {consultData.email}
                    </Title>
                  </Box>
                  <Box className="ConsultDetailForm">
                    <Title level={4} className="ConsultDetailName">
                      질문사항
                    </Title>
                    <Title level={5} className="ConsultDetailName">
                      <List>
                        {questionResultListData &&
                          questionResultListData.map((item: any) => {
                            return (
                              <ListItem
                                disablePadding
                                className="ConsultQuestionList"
                                divider
                                key={item.p_id}
                              >
                                <ListItemText
                                  primary={
                                    <>
                                      <Title
                                        level={5}
                                        className="ConsultDetailQuestionName"
                                      >
                                        Q.&nbsp;
                                        {
                                          questionData.filter(
                                            (item2: any) =>
                                              item2.p_id == item.question_id
                                          )[0].question
                                        }
                                      </Title>
                                    </>
                                  }
                                />
                                <ListItemText
                                  primary={
                                    <>
                                      <Title
                                        level={5}
                                        className="ConsultDetailName"
                                      >
                                        {questionData.filter(
                                          (item2: any) =>
                                            item2.p_id == item.question_id
                                        )[0].questiontype_id == 1 ||
                                        (questionData.filter(
                                          (item2: any) =>
                                            item2.p_id == item.question_id
                                        )[0].questiontype_id == 2 &&
                                          questionData.filter(
                                            (item2: any) =>
                                              item2.p_id == item.question_id
                                          )[0].multi == 1)
                                          ? `${item.answer}`
                                          : questionData.filter(
                                              (item2: any) =>
                                                item2.p_id == item.question_id
                                            )[0].questiontype_id == 2
                                          ? numberQuestionListData &&
                                            numberQuestionListData.filter(
                                              (items: any) =>
                                                item.question_id ==
                                                items.question_id
                                            )[item.answer - 1] &&
                                            numberQuestionListData.filter(
                                              (items: any) =>
                                                item.question_id ==
                                                items.question_id
                                            )[item.answer - 1].NumberQuestion
                                          : questionData.filter(
                                              (item2: any) =>
                                                item2.p_id == item.question_id
                                            )[0].questiontype_id == 3
                                          ? ""
                                          : ""}
                                      </Title>
                                    </>
                                  }
                                />
                              </ListItem>
                            );
                          })}
                      </List>
                    </Title>
                  </Box>
                </Box>
              </Grid>
              <Grid size={{ xs: 12, md: 12, lg: 6, xl: 6 }}>
                <Title level={3} className="ConsultDetailName">
                  <InsertPhotoIcon
                    fontSize="small"
                    className="ConsultAnswerIcon"
                  />
                  고객사진
                </Title>
                <Box className="ConsultDetailForm">
                  <ImageList sx={{ width: "100%" }} cols={1} gap={2}>
                    {consultData.files
                      ? consultData.files.map((item: any, index: any) => (
                          <ImageListItem key={index}>
                            <img
                              srcSet={`${filesList(
                                item
                              )}?w=164&h=164&fit=crop&auto=format&dpr=2 2x`}
                              src={`${filesList(item)}?auto=format`}
                              loading="lazy"
                              style={{
                                width: "100%",
                                height: "300px",
                                objectFit: "contain",
                              }}
                            />
                          </ImageListItem>
                        ))
                      : ""}
                  </ImageList>
                </Box>
              </Grid>
              <Grid size={{ xs: 12, md: 12, lg: 6, xl: 6 }}>
                <Title level={3} className="ConsultDetailName">
                  <InsertDriveFileIcon
                    fontSize="small"
                    className="ConsultAnswerIcon"
                  />
                  컨설팅 정보
                </Title>
                <Box className="ConsultDetailForm">
                  <Title level={4} className="ConsultDetailName">
                    일자
                  </Title>
                  {key &&
                  (key.state == "view" ||
                    !(key.state == "update" || consultData.finyn == 1)) ? (
                    <Title level={5} className="ConsultDetailName">
                      <ArrowForwardIos
                        fontSize="small"
                        className="ConsultAnswerIcon"
                      />
                      {consultData.consult_date.format("YYYY-MM-DD HH:mm:ss")}
                    </Title>
                  ) : (
                    <DatePicker
                      value={consultData.consult_date}
                      onChange={changeDateField}
                      name="consult_date"
                      format="YYYY-MM-DD"
                      sx={{ width: "100%" }}
                    />
                  )}
                </Box>
                <Box className="ConsultDetailForm">
                  <Title level={4} className="ConsultDetailName">
                    담당자
                  </Title>
                  {key &&
                  (key.state == "view" ||
                    !(key.state == "update" || consultData.finyn == 1)) ? (
                    <Title level={5} className="ConsultDetailName">
                      <ArrowForwardIos
                        fontSize="small"
                        className="ConsultAnswerIcon"
                      />
                      {consultData.employee}
                    </Title>
                  ) : (
                    <SelectComponent
                      variant="standard"
                      value={consultData.employee_id}
                      label={"담당자"}
                      name="employee_id"
                      menulist={employeeData}
                      menuvalue="name"
                      onChange={changeSelect}
                      fullWidth
                    />
                  )}
                </Box>
                <Box className="ConsultDetailForm">
                  <Title level={4} className="ConsultDetailName">
                    컨설팅 프로그램
                  </Title>
                  {key &&
                  (key.state == "view" ||
                    !(key.state == "update" || consultData.finyn == 1)) ? (
                    <Title level={5} className="ConsultDetailName">
                      <ArrowForwardIos
                        fontSize="small"
                        className="ConsultAnswerIcon"
                      />
                      {consultData.consult_program_name}
                    </Title>
                  ) : (
                    <SelectComponent
                      variant="standard"
                      value={consultData.consult_program_id}
                      label={"컨설팅 프로그램"}
                      name="consult_program_id"
                      menulist={consultProgramData}
                      menuvalue="name"
                      onChange={changeSelect}
                      fullWidth
                    />
                  )}
                </Box>
                <Box className="ConsultDetailForm">
                  <Title level={4} className="ConsultDetailName">
                    컨설팅 특이사항
                  </Title>
                  {key &&
                  (key.state == "view" ||
                    !(key.state == "update" || consultData.finyn == 1)) ? (
                    <Title level={5} className="ConsultDetailName">
                      <ArrowForwardIos
                        fontSize="small"
                        className="ConsultAnswerIcon"
                      />
                      {consultData.significant}
                    </Title>
                  ) : (
                    <TextComponent
                      variant="standard"
                      value={consultData.significant}
                      name="significant"
                      fullWidth
                      onChange={changeTextField}
                    />
                  )}
                </Box>
                <Box className="ConsultDetailForm">
                  <Title level={4} className="ConsultDetailName">
                    이슈사항
                  </Title>
                  {key &&
                  (key.state == "view" ||
                    !(key.state == "update" || consultData.finyn == 1)) ? (
                    <Title level={5} className="ConsultDetailName">
                      <ArrowForwardIos
                        fontSize="small"
                        className="ConsultAnswerIcon"
                      />
                      {consultData.issue}
                    </Title>
                  ) : (
                    <TextComponent
                      variant="standard"
                      value={consultData.issue}
                      name="issue"
                      fullWidth
                      onChange={changeTextField}
                    />
                  )}
                </Box>
                <Box className="ConsultDetailForm">
                  <Title level={4} className="ConsultDetailName">
                    비고
                  </Title>
                  {key &&
                  (key.state == "view" ||
                    !(key.state == "update" || consultData.finyn == 1)) ? (
                    <Title level={5} className="ConsultDetailName">
                      <ArrowForwardIos
                        fontSize="small"
                        className="ConsultAnswerIcon"
                      />
                      {consultData.memo}
                    </Title>
                  ) : (
                    <TextComponent
                      variant="standard"
                      value={consultData.memo}
                      name="memo"
                      fullWidth
                      onChange={changeTextField}
                    />
                  )}
                </Box>
              </Grid>
              <Grid size={{ xs: 12, md: 12, lg: 6, xl: 6 }}>
                <Title level={3} className="ConsultDetailName">
                  <EditIcon fontSize="small" className="ConsultAnswerIcon" />
                  컨설팅 결과
                </Title>
                {consultData.consult_program_id &&
                consultData.consult_program_id == 1 ? (
                  <>
                    <Box className="ConsultDetailForm">
                      <Title level={4} className="ConsultDetailName">
                        컬러 타입
                      </Title>
                      {key &&
                      (key.state == "view" ||
                        !(key.state == "update" || consultData.finyn == 1)) ? (
                        <Title level={5} className="ConsultDetailName">
                          <ArrowForwardIos
                            fontSize="small"
                            className="ConsultAnswerIcon"
                          />
                          {consultData.color_type_name}
                        </Title>
                      ) : (
                        <SelectComponent
                          variant="standard"
                          value={consultData.color_type}
                          label={"컬러타입"}
                          name="color_type"
                          menulist={colorTypeData}
                          menuvalue="name"
                          onChange={changeSelect}
                          fullWidth
                        />
                      )}
                    </Box>
                    <Box className="ConsultDetailForm">
                      <Title level={4} className="ConsultDetailName">
                        베스트 pccs
                      </Title>
                      {key &&
                      (key.state == "view" ||
                        !(key.state == "update" || consultData.finyn == 1)) ? (
                        <Title level={5} className="ConsultDetailName">
                          <ArrowForwardIos
                            fontSize="small"
                            className="ConsultAnswerIcon"
                          />
                          {pccConsultListData &&
                            pccConsultListData.map((item: any, index: any) => {
                              if (index == pccConsultListData.length - 1) {
                                return colorPccsData.filter(
                                  (item2: any) => item2.p_id == item.pccs_id
                                )[0].name;
                              } else {
                                return (
                                  colorPccsData.filter(
                                    (item2: any) => item2.p_id == item.pccs_id
                                  )[0].name + "/ "
                                );
                              }
                            })}
                        </Title>
                      ) : (
                        <MultiSelectComponent
                          variant="standard"
                          value={usercolorPccsConsultData}
                          label={"컬러pccs"}
                          name="color_pccs"
                          menulist={colorPccsData}
                          menuvalue="name"
                          onChange={changeMultiSelect}
                          fullWidth
                          multiple
                        />
                      )}
                    </Box>
                    <Box className="ConsultDetailForm">
                      <Title level={4} className="ConsultDetailName">
                        외형상 특징1
                      </Title>
                      {key &&
                      (key.state == "view" ||
                        !(key.state == "update" || consultData.finyn == 1)) ? (
                        <Title level={5} className="ConsultDetailName">
                          <ArrowForwardIos
                            fontSize="small"
                            className="ConsultAnswerIcon"
                          />
                          {consultData.characteristic1}
                        </Title>
                      ) : (
                        <TextComponent
                          variant="standard"
                          value={consultData.characteristic1}
                          name="characteristic1"
                          fullWidth
                          onChange={changeTextField}
                        />
                      )}
                    </Box>{" "}
                    <Box className="ConsultDetailForm">
                      <Title level={4} className="ConsultDetailName">
                        외형상 특징2
                      </Title>
                      {key &&
                      (key.state == "view" ||
                        !(key.state == "update" || consultData.finyn == 1)) ? (
                        <Title level={5} className="ConsultDetailName">
                          <ArrowForwardIos
                            fontSize="small"
                            className="ConsultAnswerIcon"
                          />
                          {consultData.characteristic2}
                        </Title>
                      ) : (
                        <TextComponent
                          variant="standard"
                          value={consultData.characteristic2}
                          name="characteristic2"
                          fullWidth
                          onChange={changeTextField}
                        />
                      )}
                    </Box>{" "}
                    <Box className="ConsultDetailForm">
                      <Title level={4} className="ConsultDetailName">
                        외형상 특징3
                      </Title>
                      {key &&
                      (key.state == "view" ||
                        !(key.state == "update" || consultData.finyn == 1)) ? (
                        <Title level={5} className="ConsultDetailName">
                          <ArrowForwardIos
                            fontSize="small"
                            className="ConsultAnswerIcon"
                          />
                          {consultData.characteristic3}
                        </Title>
                      ) : (
                        <TextComponent
                          variant="standard"
                          value={consultData.characteristic3}
                          name="characteristic3"
                          fullWidth
                          onChange={changeTextField}
                        />
                      )}
                    </Box>
                    <Box className="ConsultDetailForm">
                      <Title level={4} className="ConsultDetailName">
                        선호 브랜드 컬러
                      </Title>
                      {key &&
                      (key.state == "view" ||
                        !(key.state == "update" || consultData.finyn == 1)) ? (
                        <Title level={5} className="ConsultDetailName">
                          <ArrowForwardIos
                            fontSize="small"
                            className="ConsultAnswerIcon"
                          />
                          {consultData.brand_color}
                        </Title>
                      ) : (
                        <TextComponent
                          variant="standard"
                          value={consultData.brand_color}
                          name="brand_color"
                          fullWidth
                          onChange={changeTextField}
                        />
                      )}
                    </Box>
                  </>
                ) : consultData.consult_program_id == 2 ? (
                  <>
                    <Box className="ConsultDetailForm">
                      <Title
                        level={4}
                        className="ConsultDetailName"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        체형 타입
                        <ButtonComponent
                          fullWidth
                          variant="contained"
                          onClick={() =>
                            setBodyModal({
                              value: true,
                              state:
                                key &&
                                (key.state == "view" ||
                                  !(
                                    key.state == "update" ||
                                    consultData.finyn == 1
                                  ))
                                  ? "view"
                                  : "update",
                            })
                          }
                          className="ConsultSaveButton"
                        >
                          계산하기
                        </ButtonComponent>
                      </Title>
                      {key &&
                      (key.state == "view" ||
                        !(key.state == "update" || consultData.finyn == 1)) ? (
                        <Title level={5} className="ConsultDetailName">
                          <ArrowForwardIos
                            fontSize="small"
                            className="ConsultAnswerIcon"
                          />
                          {consultData.fit_type_name}
                        </Title>
                      ) : (
                        <SelectComponent
                          variant="standard"
                          value={consultData.fit_type}
                          label={"체형 타입"}
                          name="fit_type"
                          menulist={fitTypeData}
                          menuvalue="name"
                          onChange={changeSelect}
                          fullWidth
                          disabled={bodydisable}
                        />
                      )}
                    </Box>{" "}
                    <Box className="ConsultDetailForm">
                      <Title level={4} className="ConsultDetailName">
                        외형상 특징1
                      </Title>
                      {key &&
                      (key.state == "view" ||
                        !(key.state == "update" || consultData.finyn == 1)) ? (
                        <Title level={5} className="ConsultDetailName">
                          <ArrowForwardIos
                            fontSize="small"
                            className="ConsultAnswerIcon"
                          />
                          {consultData.characteristic1}
                        </Title>
                      ) : (
                        <TextComponent
                          variant="standard"
                          value={consultData.characteristic1}
                          name="characteristic1"
                          fullWidth
                          onChange={changeTextField}
                        />
                      )}
                    </Box>{" "}
                    <Box className="ConsultDetailForm">
                      <Title level={4} className="ConsultDetailName">
                        외형상 특징2
                      </Title>
                      {key &&
                      (key.state == "view" ||
                        !(key.state == "update" || consultData.finyn == 1)) ? (
                        <Title level={5} className="ConsultDetailName">
                          <ArrowForwardIos
                            fontSize="small"
                            className="ConsultAnswerIcon"
                          />
                          {consultData.characteristic2}
                        </Title>
                      ) : (
                        <TextComponent
                          variant="standard"
                          value={consultData.characteristic2}
                          name="characteristic2"
                          fullWidth
                          onChange={changeTextField}
                        />
                      )}
                    </Box>{" "}
                    <Box className="ConsultDetailForm">
                      <Title level={4} className="ConsultDetailName">
                        외형상 특징3
                      </Title>
                      {key &&
                      (key.state == "view" ||
                        !(key.state == "update" || consultData.finyn == 1)) ? (
                        <Title level={5} className="ConsultDetailName">
                          <ArrowForwardIos
                            fontSize="small"
                            className="ConsultAnswerIcon"
                          />
                          {consultData.characteristic3}
                        </Title>
                      ) : (
                        <TextComponent
                          variant="standard"
                          value={consultData.characteristic3}
                          name="characteristic3"
                          fullWidth
                          onChange={changeTextField}
                        />
                      )}
                    </Box>
                    <Box className="ConsultDetailForm">
                      <Title level={4} className="ConsultDetailName">
                        선호 브랜드 핏
                      </Title>
                      {key &&
                      (key.state == "view" ||
                        !(key.state == "update" || consultData.finyn == 1)) ? (
                        <Title level={5} className="ConsultDetailName">
                          <ArrowForwardIos
                            fontSize="small"
                            className="ConsultAnswerIcon"
                          />
                          {consultData.brand_fit}
                        </Title>
                      ) : (
                        <TextComponent
                          variant="standard"
                          value={consultData.brand_fit}
                          name="brand_fit"
                          fullWidth
                          onChange={changeTextField}
                        />
                      )}
                    </Box>
                  </>
                ) : consultData.consult_program_id == 3 ? (
                  <>
                    <Box className="ConsultDetailForm">
                      <Title level={4} className="ConsultDetailName">
                        컬러 타입
                      </Title>
                      {key &&
                      (key.state == "view" ||
                        !(key.state == "update" || consultData.finyn == 1)) ? (
                        <Title level={5} className="ConsultDetailName">
                          <ArrowForwardIos
                            fontSize="small"
                            className="ConsultAnswerIcon"
                          />
                          {consultData.color_type_name}
                        </Title>
                      ) : (
                        <SelectComponent
                          variant="standard"
                          value={consultData.color_type}
                          label={"컬러타입"}
                          name="color_type"
                          menulist={colorTypeData}
                          menuvalue="name"
                          onChange={changeSelect}
                          fullWidth
                        />
                      )}
                    </Box>
                    <Box className="ConsultDetailForm">
                      <Title level={4} className="ConsultDetailName">
                        베스트 pccs
                      </Title>
                      {key &&
                      (key.state == "view" ||
                        !(key.state == "update" || consultData.finyn == 1)) ? (
                        <Title level={5} className="ConsultDetailName">
                          <ArrowForwardIos
                            fontSize="small"
                            className="ConsultAnswerIcon"
                          />
                          {pccConsultListData &&
                            pccConsultListData.map((item: any, index: any) => {
                              if (index == pccConsultListData.length - 1) {
                                return colorPccsData.filter(
                                  (item2: any) => item2.p_id == item.pccs_id
                                )[0].name;
                              } else {
                                return (
                                  colorPccsData.filter(
                                    (item2: any) => item2.p_id == item.pccs_id
                                  )[0].name + "/ "
                                );
                              }
                            })}
                        </Title>
                      ) : (
                        <MultiSelectComponent
                          variant="standard"
                          value={usercolorPccsConsultData}
                          label={"컬러pccs"}
                          name="color_pccs"
                          menulist={colorPccsData}
                          menuvalue="name"
                          onChange={changeMultiSelect}
                          fullWidth
                          multiple
                        />
                      )}
                    </Box>
                    <Box className="ConsultDetailForm">
                      <Title
                        level={4}
                        className="ConsultDetailName"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        얼굴형 타입
                        {consultData.files.length > 0 && (
                          <ButtonComponent
                            fullWidth
                            variant="contained"
                            onClick={() =>
                              setFaceModal({
                                value: true,
                                state:
                                  key &&
                                  (key.state == "view" ||
                                    !(
                                      key.state == "update" ||
                                      consultData.finyn == 1
                                    ))
                                    ? "view"
                                    : "update",
                              })
                            }
                            className="ConsultSaveButton"
                          >
                            계산하기
                          </ButtonComponent>
                        )}
                      </Title>
                      {key &&
                      (key.state == "view" ||
                        !(key.state == "update" || consultData.finyn == 1)) ? (
                        <Title level={5} className="ConsultDetailName">
                          <ArrowForwardIos
                            fontSize="small"
                            className="ConsultAnswerIcon"
                          />
                          {consultData.face_type_name}
                        </Title>
                      ) : (
                        <SelectComponent
                          variant="standard"
                          value={consultData.face_type}
                          label={"얼굴형 타입"}
                          name="face_type"
                          menulist={faceTypeData}
                          menuvalue="name"
                          onChange={changeSelect}
                          fullWidth
                        />
                      )}
                    </Box>
                    <Box className="ConsultDetailForm">
                      <Title level={4} className="ConsultDetailName">
                        외형상 특징1
                      </Title>
                      {key &&
                      (key.state == "view" ||
                        !(key.state == "update" || consultData.finyn == 1)) ? (
                        <Title level={5} className="ConsultDetailName">
                          <ArrowForwardIos
                            fontSize="small"
                            className="ConsultAnswerIcon"
                          />
                          {consultData.characteristic1}
                        </Title>
                      ) : (
                        <TextComponent
                          variant="standard"
                          value={consultData.characteristic1}
                          name="characteristic1"
                          fullWidth
                          onChange={changeTextField}
                        />
                      )}
                    </Box>{" "}
                    <Box className="ConsultDetailForm">
                      <Title level={4} className="ConsultDetailName">
                        외형상 특징2
                      </Title>
                      {key &&
                      (key.state == "view" ||
                        !(key.state == "update" || consultData.finyn == 1)) ? (
                        <Title level={5} className="ConsultDetailName">
                          <ArrowForwardIos
                            fontSize="small"
                            className="ConsultAnswerIcon"
                          />
                          {consultData.characteristic2}
                        </Title>
                      ) : (
                        <TextComponent
                          variant="standard"
                          value={consultData.characteristic2}
                          name="characteristic2"
                          fullWidth
                          onChange={changeTextField}
                        />
                      )}
                    </Box>{" "}
                    <Box className="ConsultDetailForm">
                      <Title level={4} className="ConsultDetailName">
                        외형상 특징3
                      </Title>
                      {key &&
                      (key.state == "view" ||
                        !(key.state == "update" || consultData.finyn == 1)) ? (
                        <Title level={5} className="ConsultDetailName">
                          <ArrowForwardIos
                            fontSize="small"
                            className="ConsultAnswerIcon"
                          />
                          {consultData.characteristic3}
                        </Title>
                      ) : (
                        <TextComponent
                          variant="standard"
                          value={consultData.characteristic3}
                          name="characteristic3"
                          fullWidth
                          onChange={changeTextField}
                        />
                      )}
                    </Box>
                    <Box className="ConsultDetailForm">
                      <Title level={4} className="ConsultDetailName">
                        선호 브랜드 컬러
                      </Title>
                      {key &&
                      (key.state == "view" ||
                        !(key.state == "update" || consultData.finyn == 1)) ? (
                        <Title level={5} className="ConsultDetailName">
                          <ArrowForwardIos
                            fontSize="small"
                            className="ConsultAnswerIcon"
                          />
                          {consultData.brand_color}
                        </Title>
                      ) : (
                        <TextComponent
                          variant="standard"
                          value={consultData.brand_color}
                          name="brand_color"
                          fullWidth
                          onChange={changeTextField}
                        />
                      )}
                    </Box>
                  </>
                ) : consultData.consult_program_id == 4 ? (
                  <>
                    <Box className="ConsultDetailForm">
                      <Title level={4} className="ConsultDetailName">
                        컬러 타입
                      </Title>
                      {key &&
                      (key.state == "view" ||
                        !(key.state == "update" || consultData.finyn == 1)) ? (
                        <Title level={5} className="ConsultDetailName">
                          <ArrowForwardIos
                            fontSize="small"
                            className="ConsultAnswerIcon"
                          />
                          {consultData.color_type_name}
                        </Title>
                      ) : (
                        <SelectComponent
                          variant="standard"
                          value={consultData.color_type}
                          label={"컬러타입"}
                          name="color_type"
                          menulist={colorTypeData}
                          menuvalue="name"
                          onChange={changeSelect}
                          fullWidth
                        />
                      )}
                    </Box>
                    <Box className="ConsultDetailForm">
                      <Title level={4} className="ConsultDetailName">
                        베스트 pccs
                      </Title>
                      {key &&
                      (key.state == "view" ||
                        !(key.state == "update" || consultData.finyn == 1)) ? (
                        <Title level={5} className="ConsultDetailName">
                          <ArrowForwardIos
                            fontSize="small"
                            className="ConsultAnswerIcon"
                          />
                          {pccConsultListData &&
                            pccConsultListData.map((item: any, index: any) => {
                              if (index == pccConsultListData.length - 1) {
                                return colorPccsData.filter(
                                  (item2: any) => item2.p_id == item.pccs_id
                                )[0].name;
                              } else {
                                return (
                                  colorPccsData.filter(
                                    (item2: any) => item2.p_id == item.pccs_id
                                  )[0].name + "/ "
                                );
                              }
                            })}
                        </Title>
                      ) : (
                        <MultiSelectComponent
                          variant="standard"
                          value={usercolorPccsConsultData}
                          label={"컬러pccs"}
                          name="color_pccs"
                          menulist={colorPccsData}
                          menuvalue="name"
                          onChange={changeMultiSelect}
                          fullWidth
                          multiple
                        />
                      )}
                    </Box>
                    <Box className="ConsultDetailForm">
                      <Title
                        level={4}
                        className="ConsultDetailName"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        체형 타입
                        <ButtonComponent
                          fullWidth
                          variant="contained"
                          onClick={() =>
                            setBodyModal({
                              value: true,
                              state:
                                key &&
                                (key.state == "view" ||
                                  !(
                                    key.state == "update" ||
                                    consultData.finyn == 1
                                  ))
                                  ? "view"
                                  : "update",
                            })
                          }
                          className="ConsultSaveButton"
                        >
                          계산하기
                        </ButtonComponent>
                      </Title>
                      {key &&
                      (key.state == "view" ||
                        !(key.state == "update" || consultData.finyn == 1)) ? (
                        <Title level={5} className="ConsultDetailName">
                          <ArrowForwardIos
                            fontSize="small"
                            className="ConsultAnswerIcon"
                          />
                          {consultData.fit_type_name}
                        </Title>
                      ) : (
                        <SelectComponent
                          variant="standard"
                          value={consultData.fit_type}
                          label={"체형 타입"}
                          name="fit_type"
                          menulist={fitTypeData}
                          menuvalue="name"
                          onChange={changeSelect}
                          fullWidth
                          disabled={bodydisable}
                        />
                      )}
                    </Box>
                    <Box className="ConsultDetailForm">
                      <Title level={4} className="ConsultDetailName">
                        외형상 특징1
                      </Title>
                      {key &&
                      (key.state == "view" ||
                        !(key.state == "update" || consultData.finyn == 1)) ? (
                        <Title level={5} className="ConsultDetailName">
                          <ArrowForwardIos
                            fontSize="small"
                            className="ConsultAnswerIcon"
                          />
                          {consultData.characteristic1}
                        </Title>
                      ) : (
                        <TextComponent
                          variant="standard"
                          value={consultData.characteristic1}
                          name="characteristic1"
                          fullWidth
                          onChange={changeTextField}
                        />
                      )}
                    </Box>{" "}
                    <Box className="ConsultDetailForm">
                      <Title level={4} className="ConsultDetailName">
                        외형상 특징2
                      </Title>
                      {key &&
                      (key.state == "view" ||
                        !(key.state == "update" || consultData.finyn == 1)) ? (
                        <Title level={5} className="ConsultDetailName">
                          <ArrowForwardIos
                            fontSize="small"
                            className="ConsultAnswerIcon"
                          />
                          {consultData.characteristic2}
                        </Title>
                      ) : (
                        <TextComponent
                          variant="standard"
                          value={consultData.characteristic2}
                          name="characteristic2"
                          fullWidth
                          onChange={changeTextField}
                        />
                      )}
                    </Box>{" "}
                    <Box className="ConsultDetailForm">
                      <Title level={4} className="ConsultDetailName">
                        외형상 특징3
                      </Title>
                      {key &&
                      (key.state == "view" ||
                        !(key.state == "update" || consultData.finyn == 1)) ? (
                        <Title level={5} className="ConsultDetailName">
                          <ArrowForwardIos
                            fontSize="small"
                            className="ConsultAnswerIcon"
                          />
                          {consultData.characteristic3}
                        </Title>
                      ) : (
                        <TextComponent
                          variant="standard"
                          value={consultData.characteristic3}
                          name="characteristic3"
                          fullWidth
                          onChange={changeTextField}
                        />
                      )}
                    </Box>{" "}
                    <Box className="ConsultDetailForm">
                      <Title level={4} className="ConsultDetailName">
                        선호 브랜드 컬러
                      </Title>
                      {key &&
                      (key.state == "view" ||
                        !(key.state == "update" || consultData.finyn == 1)) ? (
                        <Title level={5} className="ConsultDetailName">
                          <ArrowForwardIos
                            fontSize="small"
                            className="ConsultAnswerIcon"
                          />
                          {consultData.brand_color}
                        </Title>
                      ) : (
                        <TextComponent
                          variant="standard"
                          value={consultData.brand_color}
                          name="brand_color"
                          fullWidth
                          onChange={changeTextField}
                        />
                      )}
                    </Box>
                    <Box className="ConsultDetailForm">
                      <Title level={4} className="ConsultDetailName">
                        선호 브랜드 핏
                      </Title>
                      {key &&
                      (key.state == "view" ||
                        !(key.state == "update" || consultData.finyn == 1)) ? (
                        <Title level={5} className="ConsultDetailName">
                          <ArrowForwardIos
                            fontSize="small"
                            className="ConsultAnswerIcon"
                          />
                          {consultData.brand_fit}
                        </Title>
                      ) : (
                        <TextComponent
                          variant="standard"
                          value={consultData.brand_fit}
                          name="brand_fit"
                          fullWidth
                          onChange={changeTextField}
                        />
                      )}
                    </Box>
                  </>
                ) : consultData.consult_program_id == 5 ? (
                  <>
                    <Box className="ConsultDetailForm">
                      <Title
                        level={4}
                        className="ConsultDetailName"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        체형 타입
                        <ButtonComponent
                          fullWidth
                          variant="contained"
                          onClick={() =>
                            setBodyModal({
                              value: true,
                              state:
                                key &&
                                (key.state == "view" ||
                                  !(
                                    key.state == "update" ||
                                    consultData.finyn == 1
                                  ))
                                  ? "view"
                                  : "update",
                            })
                          }
                          className="ConsultSaveButton"
                        >
                          계산하기
                        </ButtonComponent>
                      </Title>
                      {key &&
                      (key.state == "view" ||
                        !(key.state == "update" || consultData.finyn == 1)) ? (
                        <Title level={5} className="ConsultDetailName">
                          <ArrowForwardIos
                            fontSize="small"
                            className="ConsultAnswerIcon"
                          />
                          {consultData.fit_type_name}
                        </Title>
                      ) : (
                        <SelectComponent
                          variant="standard"
                          value={consultData.fit_type}
                          label={"체형 타입"}
                          name="fit_type"
                          menulist={fitTypeData}
                          menuvalue="name"
                          onChange={changeSelect}
                          fullWidth
                          disabled={bodydisable}
                        />
                      )}
                    </Box>
                    <Box className="ConsultDetailForm">
                      <Title
                        level={4}
                        className="ConsultDetailName"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        얼굴형 타입
                        {consultData.files.length > 0 && (
                          <ButtonComponent
                            fullWidth
                            variant="contained"
                            onClick={() =>
                              setFaceModal({
                                value: true,
                                state:
                                  key &&
                                  (key.state == "view" ||
                                    !(
                                      key.state == "update" ||
                                      consultData.finyn == 1
                                    ))
                                    ? "view"
                                    : "update",
                              })
                            }
                            className="ConsultSaveButton"
                          >
                            계산하기
                          </ButtonComponent>
                        )}
                      </Title>
                      {key &&
                      (key.state == "view" ||
                        !(key.state == "update" || consultData.finyn == 1)) ? (
                        <Title level={5} className="ConsultDetailName">
                          <ArrowForwardIos
                            fontSize="small"
                            className="ConsultAnswerIcon"
                          />
                          {consultData.face_type_name}
                        </Title>
                      ) : (
                        <SelectComponent
                          variant="standard"
                          value={consultData.face_type}
                          label={"얼굴형 타입"}
                          name="face_type"
                          menulist={faceTypeData}
                          menuvalue="name"
                          onChange={changeSelect}
                          fullWidth
                        />
                      )}
                    </Box>
                    <Box className="ConsultDetailForm">
                      <Title level={4} className="ConsultDetailName">
                        외형상 특징1
                      </Title>
                      {key &&
                      (key.state == "view" ||
                        !(key.state == "update" || consultData.finyn == 1)) ? (
                        <Title level={5} className="ConsultDetailName">
                          <ArrowForwardIos
                            fontSize="small"
                            className="ConsultAnswerIcon"
                          />
                          {consultData.characteristic1}
                        </Title>
                      ) : (
                        <TextComponent
                          variant="standard"
                          value={consultData.characteristic1}
                          name="characteristic1"
                          fullWidth
                          onChange={changeTextField}
                        />
                      )}
                    </Box>{" "}
                    <Box className="ConsultDetailForm">
                      <Title level={4} className="ConsultDetailName">
                        외형상 특징2
                      </Title>
                      {key &&
                      (key.state == "view" ||
                        !(key.state == "update" || consultData.finyn == 1)) ? (
                        <Title level={5} className="ConsultDetailName">
                          <ArrowForwardIos
                            fontSize="small"
                            className="ConsultAnswerIcon"
                          />
                          {consultData.characteristic2}
                        </Title>
                      ) : (
                        <TextComponent
                          variant="standard"
                          value={consultData.characteristic2}
                          name="characteristic2"
                          fullWidth
                          onChange={changeTextField}
                        />
                      )}
                    </Box>{" "}
                    <Box className="ConsultDetailForm">
                      <Title level={4} className="ConsultDetailName">
                        외형상 특징3
                      </Title>
                      {key &&
                      (key.state == "view" ||
                        !(key.state == "update" || consultData.finyn == 1)) ? (
                        <Title level={5} className="ConsultDetailName">
                          <ArrowForwardIos
                            fontSize="small"
                            className="ConsultAnswerIcon"
                          />
                          {consultData.characteristic3}
                        </Title>
                      ) : (
                        <TextComponent
                          variant="standard"
                          value={consultData.characteristic3}
                          name="characteristic3"
                          fullWidth
                          onChange={changeTextField}
                        />
                      )}
                    </Box>{" "}
                    <Box className="ConsultDetailForm">
                      <Title level={4} className="ConsultDetailName">
                        선호 브랜드 핏
                      </Title>
                      {key &&
                      (key.state == "view" ||
                        !(key.state == "update" || consultData.finyn == 1)) ? (
                        <Title level={5} className="ConsultDetailName">
                          <ArrowForwardIos
                            fontSize="small"
                            className="ConsultAnswerIcon"
                          />
                          {consultData.brand_fit}
                        </Title>
                      ) : (
                        <TextComponent
                          variant="standard"
                          value={consultData.brand_fit}
                          name="brand_fit"
                          fullWidth
                          onChange={changeTextField}
                        />
                      )}
                    </Box>
                  </>
                ) : consultData.consult_program_id == 6 ? (
                  <>
                    <Box className="ConsultDetailForm">
                      <Title level={4} className="ConsultDetailName">
                        컬러 타입
                      </Title>
                      {key &&
                      (key.state == "view" ||
                        !(key.state == "update" || consultData.finyn == 1)) ? (
                        <Title level={5} className="ConsultDetailName">
                          <ArrowForwardIos
                            fontSize="small"
                            className="ConsultAnswerIcon"
                          />
                          {consultData.color_type_name}
                        </Title>
                      ) : (
                        <SelectComponent
                          variant="standard"
                          value={consultData.color_type}
                          label={"컬러타입"}
                          name="color_type"
                          menulist={colorTypeData}
                          menuvalue="name"
                          onChange={changeSelect}
                          fullWidth
                        />
                      )}
                    </Box>
                    <Box className="ConsultDetailForm">
                      <Title level={4} className="ConsultDetailName">
                        베스트 pccs
                      </Title>
                      {key &&
                      (key.state == "view" ||
                        !(key.state == "update" || consultData.finyn == 1)) ? (
                        <Title level={5} className="ConsultDetailName">
                          <ArrowForwardIos
                            fontSize="small"
                            className="ConsultAnswerIcon"
                          />
                          {pccConsultListData &&
                            pccConsultListData.map((item: any, index: any) => {
                              if (index == pccConsultListData.length - 1) {
                                return colorPccsData.filter(
                                  (item2: any) => item2.p_id == item.pccs_id
                                )[0].name;
                              } else {
                                return (
                                  colorPccsData.filter(
                                    (item2: any) => item2.p_id == item.pccs_id
                                  )[0].name + "/ "
                                );
                              }
                            })}
                        </Title>
                      ) : (
                        <MultiSelectComponent
                          variant="standard"
                          value={usercolorPccsConsultData}
                          label={"컬러pccs"}
                          name="color_pccs"
                          menulist={colorPccsData}
                          menuvalue="name"
                          onChange={changeMultiSelect}
                          fullWidth
                          multiple
                        />
                      )}
                    </Box>
                    <Box className="ConsultDetailForm">
                      <Title
                        level={4}
                        className="ConsultDetailName"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        체형 타입
                        <ButtonComponent
                          fullWidth
                          variant="contained"
                          onClick={() =>
                            setBodyModal({
                              value: true,
                              state:
                                key &&
                                (key.state == "view" ||
                                  !(
                                    key.state == "update" ||
                                    consultData.finyn == 1
                                  ))
                                  ? "view"
                                  : "update",
                            })
                          }
                          className="ConsultSaveButton"
                        >
                          계산하기
                        </ButtonComponent>
                      </Title>
                      {key &&
                      (key.state == "view" ||
                        !(key.state == "update" || consultData.finyn == 1)) ? (
                        <Title level={5} className="ConsultDetailName">
                          <ArrowForwardIos
                            fontSize="small"
                            className="ConsultAnswerIcon"
                          />
                          {consultData.fit_type_name}
                        </Title>
                      ) : (
                        <SelectComponent
                          variant="standard"
                          value={consultData.fit_type}
                          label={"체형 타입"}
                          name="fit_type"
                          menulist={fitTypeData}
                          menuvalue="name"
                          onChange={changeSelect}
                          fullWidth
                          disabled={bodydisable}
                        />
                      )}
                    </Box>
                    <Box className="ConsultDetailForm">
                      <Title
                        level={4}
                        className="ConsultDetailName"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        얼굴형 타입
                        {consultData.files.length > 0 && (
                          <ButtonComponent
                            fullWidth
                            variant="contained"
                            onClick={() =>
                              setFaceModal({
                                value: true,
                                state:
                                  key &&
                                  (key.state == "view" ||
                                    !(
                                      key.state == "update" ||
                                      consultData.finyn == 1
                                    ))
                                    ? "view"
                                    : "update",
                              })
                            }
                            className="ConsultSaveButton"
                          >
                            계산하기
                          </ButtonComponent>
                        )}
                      </Title>
                      {key &&
                      (key.state == "view" ||
                        !(key.state == "update" || consultData.finyn == 1)) ? (
                        <Title level={5} className="ConsultDetailName">
                          <ArrowForwardIos
                            fontSize="small"
                            className="ConsultAnswerIcon"
                          />
                          {consultData.face_type_name}
                        </Title>
                      ) : (
                        <SelectComponent
                          variant="standard"
                          value={consultData.face_type}
                          label={"얼굴형 타입"}
                          name="face_type"
                          menulist={faceTypeData}
                          menuvalue="name"
                          onChange={changeSelect}
                          fullWidth
                        />
                      )}
                    </Box>
                    <Box className="ConsultDetailForm">
                      <Title level={4} className="ConsultDetailName">
                        외형상 특징1
                      </Title>
                      {key &&
                      (key.state == "view" ||
                        !(key.state == "update" || consultData.finyn == 1)) ? (
                        <Title level={5} className="ConsultDetailName">
                          <ArrowForwardIos
                            fontSize="small"
                            className="ConsultAnswerIcon"
                          />
                          {consultData.characteristic1}
                        </Title>
                      ) : (
                        <TextComponent
                          variant="standard"
                          value={consultData.characteristic1}
                          name="characteristic1"
                          fullWidth
                          onChange={changeTextField}
                        />
                      )}
                    </Box>{" "}
                    <Box className="ConsultDetailForm">
                      <Title level={4} className="ConsultDetailName">
                        외형상 특징2
                      </Title>
                      {key &&
                      (key.state == "view" ||
                        !(key.state == "update" || consultData.finyn == 1)) ? (
                        <Title level={5} className="ConsultDetailName">
                          <ArrowForwardIos
                            fontSize="small"
                            className="ConsultAnswerIcon"
                          />
                          {consultData.characteristic2}
                        </Title>
                      ) : (
                        <TextComponent
                          variant="standard"
                          value={consultData.characteristic2}
                          name="characteristic2"
                          fullWidth
                          onChange={changeTextField}
                        />
                      )}
                    </Box>{" "}
                    <Box className="ConsultDetailForm">
                      <Title level={4} className="ConsultDetailName">
                        외형상 특징3
                      </Title>
                      {key &&
                      (key.state == "view" ||
                        !(key.state == "update" || consultData.finyn == 1)) ? (
                        <Title level={5} className="ConsultDetailName">
                          <ArrowForwardIos
                            fontSize="small"
                            className="ConsultAnswerIcon"
                          />
                          {consultData.characteristic3}
                        </Title>
                      ) : (
                        <TextComponent
                          variant="standard"
                          value={consultData.characteristic3}
                          name="characteristic3"
                          fullWidth
                          onChange={changeTextField}
                        />
                      )}
                    </Box>{" "}
                    <Box className="ConsultDetailForm">
                      <Title level={4} className="ConsultDetailName">
                        선호 브랜드 컬러
                      </Title>
                      {key &&
                      (key.state == "view" ||
                        !(key.state == "update" || consultData.finyn == 1)) ? (
                        <Title level={5} className="ConsultDetailName">
                          <ArrowForwardIos
                            fontSize="small"
                            className="ConsultAnswerIcon"
                          />
                          {consultData.brand_color}
                        </Title>
                      ) : (
                        <TextComponent
                          variant="standard"
                          value={consultData.brand_color}
                          name="brand_color"
                          fullWidth
                          onChange={changeTextField}
                        />
                      )}
                    </Box>
                    <Box className="ConsultDetailForm">
                      <Title level={4} className="ConsultDetailName">
                        선호 브랜드 핏
                      </Title>
                      {key &&
                      (key.state == "view" ||
                        !(key.state == "update" || consultData.finyn == 1)) ? (
                        <Title level={5} className="ConsultDetailName">
                          <ArrowForwardIos
                            fontSize="small"
                            className="ConsultAnswerIcon"
                          />
                          {consultData.brand_fit}
                        </Title>
                      ) : (
                        <TextComponent
                          variant="standard"
                          value={consultData.brand_fit}
                          name="brand_fit"
                          fullWidth
                          onChange={changeTextField}
                        />
                      )}
                    </Box>
                  </>
                ) : (
                  <></>
                )}
              </Grid>
            </Grid>
          </CardContent>
          <Box id="ConsultDetailControlDiv">
            {key && key.state != "view" && (
              <ButtonComponent
                fullWidth
                variant="contained"
                onClick={() => handleSave()}
                className="ConsultSaveButton"
              >
                저장
              </ButtonComponent>
            )}
            <ButtonComponent
              fullWidth
              variant="contained"
              onClick={() => {
                navigate("/ConsultPage");
              }}
              className="ConsultCancelButton"
            >
              취소
            </ButtonComponent>
          </Box>
        </Card>
      </div>
      {alert && (
        <AlertComponent value={alert} setValue={setAlert} info="error">
          {alertMessage}
        </AlertComponent>
      )}
      {bodyModal.value && (
        <BodySizeModal
          open={bodyModal.value}
          sex={consultData.sex}
          onClose={(value: any) => {
            if (value.p_id) {
              setBodyResult(value);
              setBodyDisable(false);
            }
            setBodyModal((prev) => ({
              ...prev,
              value: false,
            }));
          }}
          state={bodyModal.state}
          p_id={consultData.bodyresult_id}
          cancel={true}
        ></BodySizeModal>
      )}
      {faceModal.value && (
        <FaceSizeModal
          open={faceModal.value}
          files={consultData.files}
          onClose={(value: any) => {
            if (value.clown) {
              setFaceResult(value);
            }
            setFaceModal((prev) => ({
              ...prev,
              value: false,
            }));
          }}
          state={faceModal.state}
          p_id={consultData.faceresult_id}
          cancel={true}
        ></FaceSizeModal>
      )}
      {loading && <Loading />}
    </div>
  );
}
